import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=527cc8ed&scoped=true"
import script from "./trends.vue?vue&type=script&lang=js"
export * from "./trends.vue?vue&type=script&lang=js"
import style0 from "./trends.vue?vue&type=style&index=0&id=527cc8ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cc8ed",
  null
  
)

export default component.exports